export default __webpack_public_path__ + "static/lutein-prevantivno-header-ada8cef3b1810282fc7755dc8226d992.jpg";